import fireSvg from "assets/fire.svg";

const smokeEffect = {
  type: "circleParticle",
  startRadius: 10,
  endRadius: 20,
  colour: "#777",
};
const fireEffect = { type: "imageParticle", particleHref: fireSvg };
const noEffect = { type: "none" };

export { smokeEffect, fireEffect, noEffect };
